import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { RequestItem, useOptionsApi } from '@innowise-group/core';
import { Icon, Input, Select } from '@innowise-group/mui-kit';

import { RequestFormViewProps } from '../../request-form.types';
import { FormSection } from '../form-section';
import * as Styled from './salary-section.styles';

type SalarySectionProps = Pick<RequestFormViewProps, 'disabled'>;

const SalarySection: React.FC<SalarySectionProps> = ({ disabled }) => {
  const { t } = useTranslation();
  const { currencyOptions } = useOptionsApi();
  const { control, trigger } = useFormContext<RequestItem>();

  const handleChangeSalaryLimit =
    (fieldsName: keyof RequestItem, onChange: (data: React.ChangeEvent<HTMLInputElement>) => void) =>
    (data: React.ChangeEvent<HTMLInputElement>) => {
      onChange(data);
      trigger(fieldsName);
    };

  const salaryInputProps = {
    endAdornment: (
      <Styled.SalaryIconContainer>
        <Icon type="u_lock_keyhole" size={20} />
      </Styled.SalaryIconContainer>
    ),
  };

  return (
    <FormSection title={t('pages.requests.creationModal.salary')}>
      <Controller
        name="salaryMin"
        control={control}
        render={({ field: { onChange, value, ref }, formState: { errors } }) => (
          <Input
            fullWidth
            disabled={disabled}
            label={`${t('pages.candidates.candidateCreation.salary')} min`}
            error={!!errors?.salaryMin?.message}
            helperText={errors?.salaryMin?.message}
            value={value}
            inputRef={ref}
            inputProps={{ inputMode: 'numeric' }}
            onChange={handleChangeSalaryLimit('salaryMax', onChange)}
            placeholder={t('pages.candidates.candidateCreation.enterAValue')}
            InputProps={salaryInputProps}
          />
        )}
      />
      <Controller
        name="salaryMax"
        control={control}
        render={({ field: { onChange, value, ref }, formState: { errors } }) => (
          <Input
            fullWidth
            disabled={disabled}
            label={`${t('pages.candidates.candidateCreation.salary')} max`}
            error={!!errors?.salaryMax?.message}
            helperText={errors?.salaryMax?.message}
            value={value}
            inputRef={ref}
            inputProps={{ inputMode: 'numeric' }}
            onChange={handleChangeSalaryLimit('salaryMin', onChange)}
            placeholder={t('pages.candidates.candidateCreation.enterAValue')}
            InputProps={salaryInputProps}
          />
        )}
      />
      <Controller
        name="currency"
        control={control}
        render={({ field: { onChange, value, ref }, formState: { errors } }) => (
          <Select
            disabled={disabled}
            value={value}
            onChange={onChange}
            options={currencyOptions || []}
            disableClearable
            disableSortByAlphabet={false}
            renderInput={(params) => (
              <Input
                {...params}
                required
                inputRef={ref}
                label={t('pages.candidates.candidateCreation.currency')}
                placeholder={t('pages.candidates.candidateCreation.selectCurrency')}
                error={!!errors?.currency?.message}
                helperText={errors?.currency?.message}
              />
            )}
          />
        )}
      />
    </FormSection>
  );
};

export default SalarySection;
